<template>
  <div>
    <b-modal
      id="gift-card-confirmation-modal"
      ref="gift-card-confirmation-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      modal-backdrop
      centered
      size="md"
    >
      <div class="gift-card-confirmation-modal">

        <div class="modal-content">
          <!-- Simplified Purchase Message -->
          <div class="purchase-message">
            <p class="confirmation-text">{{ confirmationMessage }}</p>
          </div>

          <!-- Action Buttons -->
          <div class="modal-actions-format">
            <button type="button" class="continue-purchase-button" @click="confirmPurchase">
              {{ recipient === 'myself' ? 'Continue with Purchase' : 'Continue with Purchase' }}
            </button>
            <button type="button" class="mt-2 cancel-btn" @click="closeModal">
              Cancel
            </button>

          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'GiftCardConfirmationModal',
  data() {
    return {
      purchaseData: {},
      recipient: 'myself',
      sharingData: null
    }
  },
  computed: {
    giftCardTypeText() {
      if (this.purchaseData.type === 'merchant') {
        return 'Merchant Gift Card';
      }
      return 'CanPay Gift Card';
    },
    recipientText() {
      return this.recipient === 'myself' ? 'Myself' : 'Someone Else';
    },
    confirmationMessage() {
      const amount = this.formatAmount(this.purchaseData.amount);

      if (this.recipient === 'myself') {
        return `Purchasing a $${amount} gift card for yourself`;
      } else if (this.recipient === 'someone-else' && this.sharingData && this.sharingData.recipientName) {
        return `Buying gift card for ${this.sharingData.recipientName} of amount $${amount}`;
      } else {
        return `Buying gift card of amount $${amount}`;
      }
    }
  },
  methods: {
    showModal(purchaseData, recipient, sharingData = null) {
      console.log('showModal called with:', { purchaseData, recipient, sharingData });
      this.purchaseData = purchaseData || {};
      this.recipient = recipient || 'myself';
      this.sharingData = sharingData;

      this.$nextTick(() => {
        console.log('Modal ref:', this.$refs['gift-card-confirmation-modal']);

        if (this.$refs['gift-card-confirmation-modal']) {
          this.$refs['gift-card-confirmation-modal'].show();
          console.log('Modal show() called');
        } else {
          console.error('Modal ref not found in showModal');
        }
      });
    },

    closeModal() {
      this.$refs['gift-card-confirmation-modal'].hide();
    },

    confirmPurchase() {
      this.$emit('confirm-purchase');
      this.closeModal();
    },

    formatAmount(amount) {
      return parseFloat(amount || 0).toFixed(2);
    },

    formatPhoneNumber(phone) {
      if (!phone) return 'N/A';
      // Remove all non-digit characters
      const cleaned = phone.replace(/\D/g, '');
      // Format as (XXX) XXX-XXXX if it's a 10-digit US number
      if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      }
      // Return original if not a standard format
      return phone;
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      } catch (error) {
        return 'N/A';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-card-confirmation-modal {
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 0;
    border: none;

    .modal-title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 28px;
      color: #999;
      cursor: pointer;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        color: #333;
      }
    }
  }

  .modal-content {
    padding: 20px;
  }

  .purchase-message {
    margin-bottom: 30px;
    text-align: center;

    .confirmation-text {
      font-size: 18px;
      font-weight: 500;
      color: #333;
      margin: 0;
      padding: 20px;
      background-color: #f8f9fa;
      border-radius: 12px;
      border: 1px solid #e9ecef;
      line-height: 1.5;
    }
  }

  .modal-actions {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #eee;

    .btn {
      padding: 12px 24px;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      min-width: 120px;

      &.btn-cancel {
        background-color: #6c757d;
        color: white;

        &:hover {
          background-color: #5a6268;
        }
      }

      &.btn-continue {
        background-color: #179346;
        color: white;

        &:hover {
          background-color: #0d5a2b;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .gift-card-confirmation-modal {
    .purchase-message {
      .confirmation-text {
        font-size: 16px;
        padding: 15px;
      }
    }

    .modal-actions {
      flex-direction: column;

      .btn {
        width: 100%;
      }
    }
  }
}
.modal-actions-format{
  display:flex;
  flex-direction: column;
}
.continue-purchase-button{
  background-color:#000000;
  padding:15px 20px;
  color:#ffffff;
  font-weight:600;
  border-radius:8px;
  font-weight:'Open Sans';
  border:none;
}
.cancel-btn{
  background-color:#EDEDED;
  padding:15px 20px;
  color:#000000;
  font-weight:600;
  border-radius:8px;
  font-weight:'Open Sans';
  border:none;

}
</style>
